<template>
    <div class="na-form">
        <div v-if="topicMemberRoleDetail" class="left">
            <DxTabPanel>
                <DxItem title="Basisdaten">
                    <div class="dx-fieldset">
                        <div class="dx-field">
                            <div class="dx-field-label">ID:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='topicMemberRoleDetail.TmrId' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Name:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='topicMemberRoleDetail.TmrName' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Erstellt am:</div>
                            <div class="dx-field-value">
                                <DxDateBox :value='topicMemberRoleDetail.TmrCreatedOn' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Erstellt von:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='topicMemberRoleDetail.TmrCreatedBy' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Geändert am:</div>
                            <div class="dx-field-value">
                                <DxDateBox :value='topicMemberRoleDetail.TmrChangedOn' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Geändert von:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='topicMemberRoleDetail.TmrChangedBy' :readOnly="true" />
                            </div>
                        </div>
                    </div>
                </DxItem> 
            </DxTabPanel>
            <div class="na-buttons-row">
                <div>
                    <DxButton :width="120"
                              text="Speichern"
                              :type="saveButtonType"
                              :disabled="saveButtonDisabled"
                              styling-mode="contained"
                              @click="onSaveClick($event)" />
                </div>
                <div>
                    <DxButton :width="120"
                              text="Löschen"
                              type="danger"
                              styling-mode="contained"
                              @click="onDeleteClick($event)" />
                </div>

                <div>
                    <DxButton :width="120"
                              text="Zurück"
                              type="back"
                              styling-mode="contained"
                              @click="onCancelClick($event)" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { DxTextBox } from 'devextreme-vue/text-box'
    import { DxButton } from 'devextreme-vue/button'
    import { DxDateBox } from 'devextreme-vue/date-box'
    import { DxTabPanel, DxItem } from 'devextreme-vue/tab-panel'
    import { confirm } from "devextreme/ui/dialog"
    import notify from 'devextreme/ui/notify'
    import $ from 'jquery'


    export default {
        name: 'TopicMemberRoleDetail',
        components: {
            DxButton,
            DxTextBox,
            DxDateBox,
            DxTabPanel,
            DxItem,
        },
        data() {
            return {
                post: null,
                files: [],
                isSaving: false
            };
        },
        props: {
            tmrId: {
                type: [Number],
                required: true,
                default: 0
            }
        },
        watch: {
            topicMemberRoleDetailText: function (newVal, oldVal) {
                if (oldVal != "{}" && oldVal != newVal) {
                    this.$store.state.topicMemberRoleStore.topicMemberRoleDetailChanged = true
                }
            }, 
            changed: function (newVal) {
                if (!newVal && this.isSaving) {
                    this.isSaving = false
                    notify("The changes were saved successfully")
                }
            },
        },
        created: function () {
        },
        mounted: function () {
            this.$store.dispatch("getTopicMemberRoleDetail", { tmrId: this.tmrId })
        },
        computed: {
            topicMemberRoleDetail() {
                return this.$store.state.topicMemberRoleStore.topicMemberRoleDetail
            },
            topicMemberRoleDetailText() {
                return JSON.stringify(this.$store.state.topicMemberRoleStore.topicMemberRoleDetail)
            },
            saveButtonType() {
                return this.changed
                    ? "success" : "normal"
            },
            saveButtonDisabled() {
                return this.changed
                    ? false : true
            },
            changed() {
                return this.$store.state.topicMemberRoleStore.topicMemberRoleDetailChanged
            }
        },
        methods: {
            onCancelClick() {
                $("form").attr("action", window.location.pathname + "?action=cancel").submit();
            },
            onSaveClick() {
                this.isSaving = true
                this.$store.dispatch("saveTopicMemberRoleDetail")
            },
            onDeleteClick() {
                let result = confirm("Sind Sie sicher, dass Sie die Rolle löschen möchten? Ein Löschen ist nicht möglich, wenn bereits verknüpfte Datensätze bestehen", "Löschen bestätigen");
                result.then((dialogResult) => {
                    if (dialogResult) {
                        var result2 = this.$store.dispatch("deleteTopicMemberRole", { tmrId: this.tmrId })
                        result2.then(() => {
                            $("form").attr("action", window.location.pathname + "?action=cancel").submit();
                        });
                    }
                });
            },
        }
    }
</script>
<style>

    div {
        text-align: left;
    }

    .options {
        margin-top: 20px;
        padding: 20px;
        background-color: rgba(191, 191, 191, 0.15);
        box-sizing: border-box;
        width: 100%;
    }

    .html-dx-field {
        width: 700px;
        height: 300px;
    }

    .html-label {
        padding-right: 200px
    }
</style>
